import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9847)">
      <g clip-path="url(#clip1_5457_9847)">
        <path
          d="M1.47935 5H11.9856C12.1757 5 12.3296 5.15032 12.3296 5.33597V10.1438C12.3296 10.444 12.1505 10.7165 11.8715 10.8413L10.5482 11.4345C10.4836 11.4636 10.4419 11.5266 10.4419 11.5964C10.4419 11.6654 10.4822 11.7275 10.5459 11.757L11.8812 12.3771C12.1551 12.5042 12.3296 12.7739 12.3296 13.0705V18.2636C12.3296 18.4492 12.1757 18.5996 11.9856 18.5996H1.47935C0.93837 18.5996 0.5 18.1714 0.5 17.6431V5.95647C0.5 5.42813 0.93837 5 1.47935 5ZM7.17772 14.0663C7.44566 14.0663 7.63668 14.031 7.75028 13.9608C7.87397 13.8901 7.93582 13.7594 7.93582 13.568V13.5376C7.93582 13.3362 7.86892 13.1949 7.73471 13.1143C7.61102 13.0338 7.39945 12.9936 7.10031 12.9936H5.1416V14.0663H7.17772ZM7.08517 10.3944C7.55975 10.3944 7.79705 10.2279 7.79705 9.89555V9.81994C7.79705 9.62847 7.7352 9.4974 7.61151 9.42716C7.49791 9.34663 7.30732 9.30637 7.03889 9.30637H5.14206V10.3944H7.08566H7.08517ZM13.2201 12.9484H17.5497C17.5497 13.2911 17.6116 13.5278 17.7353 13.6588C17.8695 13.7899 18.06 13.8552 18.3078 13.8552C18.7306 13.8552 18.9423 13.6185 18.9423 13.1448C18.9423 12.913 18.8699 12.7471 18.7256 12.646C18.5914 12.5453 18.3852 12.4948 18.1068 12.4948H15.7239V10.742L19.3907 9.85037H13.2201C13.0479 9.85037 12.9081 9.71392 12.9081 9.54571V5.25455C12.9081 5.11408 13.0249 5 13.1688 5H23.3196C23.8606 5 24.2989 5.42813 24.2989 5.95647V9.386C24.2989 9.77342 24.0263 10.1103 23.6407 10.2002L19.623 11.1352L19.8085 11.1657H23.643C24.1161 11.1657 24.5 11.5406 24.5 12.0026V17.6435C24.5 18.1719 24.0616 18.6 23.5207 18.6H13.1688C13.0249 18.6 12.9081 18.4859 12.9081 18.3455V13.253C12.9081 13.0849 13.0479 12.9484 13.2201 12.9484Z"
          fill="#ECEDEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5457_9847">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
      <clipPath id="clip1_5457_9847">
        <rect
          width="24"
          height="13.6"
          fill="white"
          transform="translate(0.5 5)"
        />
      </clipPath>
    </defs>
  </svg>
)
